import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellServiceItemName } from 'ui/Element/List/Item/Cell/ServiceItem/Name'

export default CellHOC(
  LabeledHOC(
    props => props.labels.device, ListItemCellServiceItemName,
  ),
)
